var map = {
	"./en/main.json": [
		315,
		1
	],
	"./en/main.kay.json": [
		316,
		2
	],
	"./en/main.peo.json": [
		317,
		3
	],
	"./en/main.zal.json": [
		318,
		4
	],
	"./es/main.json": [
		319,
		5
	],
	"./es/main.zal.json": [
		320,
		6
	],
	"./fr/main.json": [
		321,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 88;
module.exports = webpackAsyncContext;